import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { WindowRef } from '@spartacus/core';

@Injectable({
  providedIn: 'root',
})
export class CustomStorefrontService {
  constructor(
    protected winRef: WindowRef,
    @Inject(PLATFORM_ID) private platformId: any
  ) { }

  setInfoForRegister(): void {
    const self = this;
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(function () {
        const targetEl = self.winRef?.document?.getElementById('chefsarea-professional');
        if (targetEl) {
          self.winRef?.localStorage?.setItem('isProfessional', 'true');
        } else {
          self.winRef?.localStorage?.setItem('isProfessional', 'false');
        }
      }, 600);
    }
  }
}
